/** Invoice line description for freight rows. */
export function buildFreightInvoiceLineDescription({
  serviceCode,
  jobNo,
  tranMonth,
  tranYear,
  billFedex = false,
  billUps = false,
} = {}) {
  const code = String(serviceCode ?? "").trim();
  const jacket = String(jobNo ?? "").trim();
  const month = String(tranMonth ?? "").trim();
  const year = String(tranYear ?? "").trim();
  const period = month && year ? `${month}/${year}` : year || month;
  const carriers = [];
  if (billFedex) {
    carriers.push("FedEx");
  }
  if (billUps) {
    carriers.push("UPS");
  }
  const parts = [];
  if (code) {
    parts.push(code);
  }
  parts.push("Freight");
  if (carriers.length > 0) {
    parts.push(carriers.join("/"));
  }
  if (jacket) {
    parts.push(jacket);
  }
  if (period) {
    parts.push(period);
  }
  return parts.join(" ").trim();
}
